"use scrict";

var $ = require("jquery");
var Isotope = require("isotope-layout");
var MobileDetect = require('mobile-detect'),
    md = new MobileDetect(window.navigator.userAgent);

var ishome;

if(localStorage.getItem('aaltovcd-bg')){
  if(localStorage.getItem('aaltovcd-bg')=='black'){
    $('html').addClass('black').css({
      '--data-primary' : '#ffffff',
      '--data-bg' : '#000000',
    });
  }
}

$(function(){
  detects();

  ishome = $('body').hasClass('blog');

  if($('.iso-wrap').length>0){
    initisotope();
  }

  binds();

  initlazy();

  initsearch();
  initviewtogs();
  initfilters();
  initprojectviewer();
});

function initlazy(){
  $(window).scroll(function(){
    $('[data-src]:visible').each(function(){
      var rect = this.getBoundingClientRect();
      if(rect.top < window.innerHeight*2 && rect.bottom > -window.innerHeight){
        $(this).attr('src', $(this).attr('data-src'));
        $(this).attr('srcset', $(this).attr('data-srcset'));
        $(this).removeAttr('data-src data-srcset');
      }
    });
  });
  $(window).scroll();
  $(window).on('load', function(){
    $(window).scroll();
  });
}

function binds(){
  $('.arr-up a').click(function(e){
    e.preventDefault();
    $('html,body').animate({
      'scrollTop' : 0
    }, 800);
  });
}

var iso;
var blocks;
function initisotope(){
  iso = new Isotope( '.iso-wrap', {
    itemSelector: '.post-block',
    masonry: {
      gutter: 2,
      transitionDelay: 0,
      // columnWidth: 200
    }
  });
  iso.on('arrangeComplete', function(){
    $(window).scroll();
  });
  blocks = $('.post-block:not(.empty-one)');
  blocks.each(function(){
    this.searchText = $(this).html().toLowerCase();
  });

  setTimeout(function(){
    iso.arrange();
  },100);
}

var rememberPosition = 0;
function initprojectviewer(){
  $('.post-block a[rel="bookmark"]').click(function(e){
    rememberPosition = $(window).scrollTop();
    var parentBlock = $(this).parents('.post-block');
    e.preventDefault();
    $(parentBlock).addClass('open');
    $('body').addClass('single-post')
    $(window).scrollTop(0);
    $(window).scroll();
  });

  $('.images .oembed-wrap iframe[width][height]').each(function(){
    var ratio = ($(this).attr('height')/$(this).attr('width')) * 100;
    $(this).parent('.oembed-wrap').css('padding-bottom',ratio+'%');
  });

  $('.post-close').click(function(e){
    e.preventDefault();
    if($('.post-block').length==1){
      window.location.href = $('a[rel="home"]').attr('href');
    } else {
      $('.post-block.open').removeClass('open');
      $('body').removeClass('single-post');
      $(window).scrollTop(rememberPosition);
      if(iso){
        iso.arrange();
        setTimeout(function(){
          $(window).scrollTop(rememberPosition);
          iso.arrange();
        },100);
      }
    }
  });
}

function delayType(what, idx, delay) {
  setTimeout(function(){
    var toType = '';
    for(var i=0;i<idx;i++){
      toType += what[i];
    }
    $('#s').attr('placeholder',toType);
  }, delay);
}

function delayRemove(what, idx, delay) {
  setTimeout(function(){
    var toType = what.substr(0, idx);
    $('#s').attr('placeholder',toType);
  }, delay);
}

var searchAutoTypeInterval;
var searchDelay;
function initsearch(){
  var searchAutoTypeWords = $('.tag, .cat');
  if($('#s').val()==''){
    searchAutoTypeInterval = setInterval(function(){
      var randomTag = searchAutoTypeWords[Math.floor(Math.random() * searchAutoTypeWords.length)];
      var randomTagText = $(randomTag).text().trim().toLowerCase();
      var randomTagLetters = randomTagText.split('');
      if($(randomTag).hasClass('cat')){ randomTagLetters.unshift('/'); }
      var typeSpeed = 30;

      // remove
      var curWord = $('#s').attr('placeholder').split('');
      for(var c=0;c<curWord.length+1;c++){
        var delayAmt = c * typeSpeed;
        var curText = $('#s').attr('placeholder');
        delayRemove(curText, curWord.length-c, delayAmt);
      }

      // tye
      setTimeout(function(){
        for(var i=0; i < randomTagLetters.length; i++){
          var delayAmt = i * typeSpeed;
          delayType(randomTagLetters, i+1, delayAmt);
        }
      }, curWord.length * typeSpeed + 100);
    }, 3000);
  }
  $('#s').on('focus',function(){
    console.log('Interval cleared');
    clearInterval(searchAutoTypeInterval);
  });
  $('#s').on('input',function(){
    clearInterval(searchAutoTypeInterval);
    var search = $(this).val();

    clearTimeout(searchDelay);
    searchDelay = setTimeout(function(){
      doSearch(search);
    },400);

  });
  $('#search-form').submit(function(e){
    e.preventDefault();
    console.log('submitted');
    if($('.iso-wrap .post-block').length==0){
      var val = $('#s').val();
      window.location.href = $('a[rel="home"]').attr('href')+'#search='+val;
    } else {
      $('#s').trigger('input');
    }
  });
}

function doSearch(search){

  search = search.replace(/\b(and|or|for|the|but|etc|if|a|an|)\b/g, '').trim();
  // search = search.replace('/(^| ).( |$)/', '');
  search = search.replace(/ [a-zA-Z0-9äëïöÄËÜÏÖ](?= )/g, '');
  search = search.replace(/\s\s+/g, ' ').trim();
  search = search.replace('#','');
  search = search.replace('/','');


  var searchTerms = search.split(' ');
  var foundOnPartly = false;
  if(search.length>1){

    var filtered = [];
    $(blocks).each(function(blockIdx){
      var block = blocks[blockIdx];

      var fullMatchRegex = new RegExp("\\b" + search + "\\b").test(block.searchText);
      //console.log(fullMatchRegex);
      if(fullMatchRegex){
        // if(block.searchText.indexOf(search)>-1){
        //console.log('MATCH on full search "'+search+'"', block);
        filtered.push('#'+$(block).attr('id'));
        foundOnPartly = false;
      } else {
        $(searchTerms).each(function(termIdx) {
          var singleTerm = searchTerms[termIdx];

          var singleTermRegex = new RegExp("\\b" + singleTerm + "\\b").test(block.searchText);
          if(singleTermRegex){
            // if(block.searchText.indexOf(singleTerm)>-1){
            //console.log('MATCH on partly search "'+search+'"', block);
            filtered.push('#'+$(block).attr('id'));
            foundOnPartly = true;
          }
        });
      }
    });

    filtered = $.grep(filtered, function(v, k){
      return $.inArray(v, filtered) === k;
    });


    if(iso){
      if(filtered.length>0){
        iso.arrange({
          filter: filtered
        });
      } else {
        iso.arrange({
          filter: '*'
        });
      }
      var foundCount = filtered.length;
      if(foundOnPartly){
        var termsString = searchTerms.join(', ').trim();
        $('.iso-results p').text('[ '+foundCount+' for "'+termsString+'" ]');
      } else {
        $('.iso-results p').text('[ '+foundCount+' for "'+search+'" ]');
      }
      if(foundCount==0){
        $('#s').addClass('no-results');
      } else {
        $('#s').removeClass('no-results');
      }
    }
  } else {
    $('.iso-results p').text('[ type more ]');
    if(search.length<1){
      $('.iso-results p').text('');
      $('#s').removeClass('no-results');
      if(iso){
        iso.arrange({
          filter: '*'
        });
      }
    }
  }

  if(iso){
    setTimeout(function(){
      iso.arrange();
    },100);
  }
}

function initviewtogs(){
  if(localStorage.getItem('aaltovcd-view')){
    if(localStorage.getItem('aaltovcd-view')=='view-list'){
      $('.home-blocks').removeClass('view-grid').addClass('view-list');
      if(iso) iso.arrange();
    }
  }

  $('.views a').click(function(e){
    e.preventDefault();
    var href = $(this).attr('href');
    if(href.indexOf('view')>-1){
      var w = href.substr(1);
      $('.home-blocks').removeClass('view-grid view-list').addClass(w);
      if(iso){
        iso.arrange();
        setTimeout(function(){
          iso.arrange();
        },100);
      }
      localStorage.setItem('aaltovcd-view',w);
    } else if (href.indexOf('color')>-1){
      var w = href.split('color-')[1];
      if(w=='black'){
        $('.aalto-logo img').attr('src',$('.aalto-logo img').attr('data-src-white'));
        $('html').addClass('black').css({
          '--data-primary' : '#ffffff',
          '--data-bg' : '#000000',
        });
      } else {
        $('.aalto-logo img').attr('src',$('.aalto-logo img').attr('data-src-black'));
        $('html').removeClass('black').css({
          '--data-primary' : '#000000',
          '--data-bg' : '#ffffff',
        });
      }
      localStorage.setItem('aaltovcd-bg',w);
    }
  });
}

function initfilters(){
  $('a[href*="category/"]').each(function(){
    var id = $(this).attr('href').split('/category/')[1].replace('/','');
    $(this).attr('data-filter','.category-'+id);
  });
  $('a[href*="tag/"]').each(function(){
    var id = $(this).attr('href').split('/tag/')[1].replace('/','');
    $(this).attr('data-filter','.tag-'+id);
  });

  $('a[data-filter]').click(function(e){
    e.preventDefault();
    var inSearch = $('#s').val().indexOf($(this).text().toLowerCase()) > -1;
    var isCur = $(this).hasClass('cur-filt');
    $('.post-block.open').removeClass('open');
    $('body').removeClass('single-post');
    if(inSearch || isCur){
      if(iso){
        iso.arrange({
          filter: '*'
        });
        setTimeout(function(){
          iso.arrange();
        },100);
      }
      $(this).removeClass('cur-filt');
      $('#s').val('');
    } else {
      $('.cur-filt').removeClass('cur-filt');
      $(this).addClass('cur-filt');
      var filter = $(this).attr('data-filter');
      console.log(filter);
      if(iso){
        iso.arrange({
          filter: filter
        });
        setTimeout(function(){
          iso.arrange();
        },100);
      }
      var t = $(this).text();
      var text = t.indexOf('#') < 0 ? '/'+t.toLowerCase() : t.toLowerCase();
      $('#s').val(text);
      setTimeout(function(){
        $('#s').trigger('input');
      }, 1);
    }
  });
}

function detects(){
  if(md.mobile()) $('html').addClass('mobile');
  if(md.phone()) $('html').addClass('phone');
  if(md.tablet()) $('html').addClass('tablet');
  if(!md.mobile()&&!md.tablet()) $('html').addClass('desktop');
  $('html').addClass(md.userAgent());
  $('html').addClass(md.os());
  if(md.version()){
    $('html').addClass(md.userAgent()+md.version());
  }
  if($('html').hasClass('black')){
    $('.aalto-logo img').attr('src',$('.aalto-logo img').attr('data-src-white'));
  }
}
